module.exports = __webpack_public_path__ + "img/file_icon.f6ddd9a8.svg";